import { useState, useEffect } from 'react'

const API = `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}`

function AdminLogs() {
    const [logs, setLogs] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState('')
    const [pagina, setPagina] = useState(1)
    const [totalPaginas, setTotalPaginas] = useState(1)

    // Estados do Modal de Detalhes
    const [logSelecionado, setLogSelecionado] = useState(null)
    const [alvoDetalhes, setAlvoDetalhes] = useState(null)
    const [detalhesCarregando, setDetalhesCarregando] = useState(false)
    const [erroDetalhes, setErroDetalhes] = useState('')

    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    useEffect(() => {
        carregarLogs()
    }, [pagina])

    const carregarLogs = async () => {
        setLoading(true)
        setErro('')
        try {
            const params = new URLSearchParams({ page: pagina, limit: 20 })
            const res = await fetch(`${API}/api/admin/logs?${params}`, { headers })
            if (!res.ok) throw new Error('Erro ao carregar logs')

            const data = await res.json()
            setLogs(data.logs || data || [])
            setTotalPaginas(data.totalPages || data.totalPaginas || 1)
        } catch (error) {
            console.error('Erro:', error)
            setErro('Não foi possível carregar os logs.')
        } finally {
            setLoading(false)
        }
    }

    // Buscar detalhes e Live State no banco de dados ao clicar na linha
    const abrirDetalhes = async (log) => {
        setLogSelecionado(log)
        setAlvoDetalhes(null)
        setErroDetalhes('')
        setDetalhesCarregando(true)

        try {
            const res = await fetch(`${API}/api/admin/logs/${log.id}`, { headers })
            if (!res.ok) throw new Error('Erro ao carregar live state do alvo')
            const data = await res.json()
            
            // Atualiza com dados completos do admin e o Live State do alvo
            setLogSelecionado(data.log || log)
            setAlvoDetalhes(data.alvo_detalhes)
        } catch (error) {
            console.error('Erro ao buscar live state do log:', error)
            setErroDetalhes('Não foi possível buscar as informações em tempo real deste alvo no banco de dados.')
        } finally {
            setDetalhesCarregando(false)
        }
    }

    const formatDateTime = (date) => {
        if (!date) return '—'
        const d = new Date(date)
        return `${d.toLocaleDateString('pt-BR')} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
    }

    // Tradutor e estilização dinâmica de ações administrativas
    const getActionTranslation = (acao) => {
        const translations = {
            'ALTERAR_CARGO': { label: 'Alterar Cargo 🛡️', color: '#c084fc', bg: 'rgba(168, 85, 247, 0.15)' },
            'REMOVER_MOTORISTA': { label: 'Remover Motorista 🚫', color: '#f87171', bg: 'rgba(239, 68, 68, 0.15)' },
            'ADICIONAR_CREDITOS': { label: 'Adicionar Créditos 🎫', color: '#60a5fa', bg: 'rgba(59, 130, 246, 0.15)' },
            'ATIVAR_PLANO_PRO': { label: 'Plano PRO ⚡', color: '#fbbf24', bg: 'rgba(245, 158, 11, 0.15)' },
            'ATIVAR_MOTORISTA': { label: 'Ativar Motorista ✅', color: '#38bdf8', bg: 'rgba(14, 165, 233, 0.15)' },
            'ATIVAR_USUARIO': { label: 'Ativar Usuário 👤', color: '#4ade80', bg: 'rgba(34, 197, 94, 0.15)' },
            'DESATIVAR_USUARIO': { label: 'Banir Usuário 🚫', color: '#f87171', bg: 'rgba(239, 68, 68, 0.15)' },
            'DELETAR_ANUNCIO': { label: 'Deletar Anúncio 🗑️', color: '#f87171', bg: 'rgba(239, 68, 68, 0.15)' },
            'LIBERAR_EDICAO': { label: 'Liberar Edição 📝', color: '#60a5fa', bg: 'rgba(59, 130, 246, 0.15)' },
            'DESTACAR_ANUNCIO': { label: 'Destacar Anúncio ⭐', color: '#fbbf24', bg: 'rgba(245, 158, 11, 0.15)' },
            'REMOVER_DESTAQUE': { label: 'Remover Destaque 🌟', color: '#94a3b8', bg: 'rgba(100, 116, 139, 0.15)' },
            'CRIAR_CUPOM': { label: 'Criar Cupom 🎫', color: '#4ade80', bg: 'rgba(34, 197, 94, 0.15)' },
            'ATUALIZAR_CUPOM': { label: 'Atualizar Cupom 🎫', color: '#60a5fa', bg: 'rgba(59, 130, 246, 0.15)' },
            'DESATIVAR_CUPOM': { label: 'Desativar Cupom 🚫', color: '#f87171', bg: 'rgba(239, 68, 68, 0.15)' },
        }
        return translations[acao] || { label: acao, color: '#f8fafc', bg: 'rgba(255, 255, 255, 0.1)' }
    }

    return (
        <div>
            <div className="admin-section-header" style={{ marginBottom: '1.5rem' }}>
                <h3>📋 Logs de Auditoria</h3>
            </div>

            {erro && <div className="admin-error">{erro}</div>}

            {loading ? (
                <div className="admin-loading">
                    <div className="spinner"></div>
                    <span>Carregando logs...</span>
                </div>
            ) : (
                <div className="admin-section">
                    <div className="admin-table-wrapper">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Admin</th>
                                    <th>Ação</th>
                                    <th>Alvo</th>
                                    <th>Detalhes</th>
                                    <th>Data / Hora</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.length > 0 ? (
                                    logs.map((log, i) => (
                                        <tr 
                                            key={log.id || i} 
                                            onClick={() => abrirDetalhes(log)}
                                            style={{ cursor: 'pointer', transition: 'all 0.15s ease' }}
                                            title="Clique para ver os detalhes profundos desta ação"
                                            className="admin-log-row"
                                        >
                                            <td data-label="Admin" style={{ color: '#f8fafc', fontWeight: 500 }}>
                                                {log.admin_nome || log.adminNome || '—'}
                                            </td>
                                            <td data-label="Ação">
                                                <span style={{
                                                    background: getActionTranslation(log.acao).bg,
                                                    color: getActionTranslation(log.acao).color,
                                                    padding: '2px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '0.8rem',
                                                    fontWeight: 600,
                                                    border: `1px solid ${getActionTranslation(log.acao).color}15`
                                                }}>
                                                    {getActionTranslation(log.acao).label}
                                                </span>
                                            </td>
                                            <td data-label="Alvo">{log.alvo || '—'}</td>
                                            <td data-label="Detalhes" style={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {log.detalhes || '—'}
                                            </td>
                                            <td data-label="Data / Hora" style={{ whiteSpace: 'nowrap' }}>
                                                {formatDateTime(log.criado_em || log.criadoEm)}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
                                            Nenhum log encontrado.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="admin-pagination">
                        <button disabled={pagina <= 1} onClick={() => setPagina(p => p - 1)}>
                            ← Anterior
                        </button>
                        <span className="page-info">Página {pagina} de {totalPaginas}</span>
                        <button disabled={pagina >= totalPaginas} onClick={() => setPagina(p => p + 1)}>
                            Próxima →
                        </button>
                    </div>
                </div>
            )}

            {/* Modal Premium de Detalhes Profundos */}
            {logSelecionado && (
                <div 
                    className="admin-modal-overlay" 
                    style={{ display: 'flex' }} 
                    onClick={() => setLogSelecionado(null)}
                >
                    <div 
                        className="admin-modal" 
                        style={{ 
                            maxWidth: '650px', 
                            background: 'rgba(15, 23, 42, 0.96)',
                            backdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.08)',
                            borderRadius: '16px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.75)',
                            padding: '1.75rem',
                            animation: 'adminModalFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
                        }} 
                        onClick={(e) => e.stopPropagation()}
                    >
                        
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', borderBottom: '1px solid rgba(255, 255, 255, 0.08)', paddingBottom: '0.75rem' }}>
                            <div>
                                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700, color: '#f8fafc', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    📋 Detalhes da Auditoria
                                </h3>
                                <span style={{ fontSize: '0.75rem', color: '#64748b', fontFamily: 'monospace' }}>
                                    Registro #{logSelecionado.id || '—'}
                                </span>
                            </div>
                            <button 
                                onClick={() => setLogSelecionado(null)}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '32px',
                                    height: '32px',
                                    cursor: 'pointer',
                                    color: '#94a3b8',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '1.2rem',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(239, 68, 68, 0.15)'; e.currentTarget.style.color = '#ef4444' }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)'; e.currentTarget.style.color = '#94a3b8' }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxHeight: '68vh', overflowY: 'auto', paddingRight: '4px' }}>
                            
                            {/* Grid: Admin e Ação */}
                            <div className="admin-grid-2" style={{ gap: '1rem' }}>
                                {/* Administrador */}
                                <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '0.75rem 1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
                                    <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '4px' }}>
                                        Administrador Responsável
                                    </span>
                                    <span style={{ color: '#f8fafc', fontWeight: 600, display: 'block', fontSize: '0.9rem' }}>
                                        {logSelecionado.admin_nome || logSelecionado.adminNome || '—'}
                                    </span>
                                    <span style={{ color: '#94a3b8', fontSize: '0.75rem', display: 'block', marginTop: '2px', wordBreak: 'break-all' }}>
                                        {logSelecionado.admin_email || '—'}
                                    </span>
                                    <span style={{ color: '#475569', fontSize: '0.65rem', fontFamily: 'monospace', display: 'block', marginTop: '4px' }}>
                                        ID: {logSelecionado.admin_id || '—'}
                                    </span>
                                </div>

                                {/* Ação */}
                                <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '0.75rem 1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.04)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                        Ação Executada
                                    </span>
                                    <div>
                                        <span style={{
                                            background: getActionTranslation(logSelecionado.acao).bg,
                                            color: getActionTranslation(logSelecionado.acao).color,
                                            padding: '4px 10px',
                                            borderRadius: '6px',
                                            fontSize: '0.75rem',
                                            fontWeight: 700,
                                            display: 'inline-block',
                                            border: `1px solid ${getActionTranslation(logSelecionado.acao).color}22`
                                        }}>
                                            {getActionTranslation(logSelecionado.acao).label}
                                        </span>
                                    </div>
                                    <span style={{ color: '#475569', fontSize: '0.65rem', fontFamily: 'monospace', display: 'block', marginTop: '6px' }}>
                                        CÓDIGO: {logSelecionado.acao}
                                    </span>
                                </div>
                            </div>

                            {/* Alvo da Ação */}
                            <div style={{ background: 'rgba(255, 255, 255, 0.02)', padding: '0.75rem 1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
                                <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '4px' }}>
                                    Alvo Registrado
                                </span>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
                                    <span style={{
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        color: '#cbd5e1',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        fontSize: '0.7rem',
                                        fontWeight: 600,
                                        textTransform: 'uppercase'
                                    }}>
                                        {logSelecionado.alvo_tipo === 'usuario' ? '👤 Usuário' : logSelecionado.alvo_tipo === 'anuncio' ? '📢 Anúncio' : '🎫 Cupom'}
                                    </span>
                                    <strong style={{ color: '#f8fafc', fontSize: '0.9rem' }}>
                                        {logSelecionado.alvo || '—'}
                                    </strong>
                                </div>
                                <span style={{ color: '#475569', fontSize: '0.65rem', fontFamily: 'monospace', display: 'block', marginTop: '6px' }}>
                                    ID do Alvo: {logSelecionado.alvo_id || '—'}
                                </span>
                            </div>

                            {/* Detalhes Históricos */}
                            <div style={{ background: 'rgba(30, 41, 59, 0.4)', padding: '1rem', borderRadius: '8px', border: '1px solid rgba(255, 255, 255, 0.06)' }}>
                                <span style={{ fontSize: '0.7rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.5px', display: 'block', marginBottom: '6px' }}>
                                    Registro de Evento (Detalhes)
                                </span>
                                <p style={{ color: '#e2e8f0', margin: 0, fontSize: '0.875rem', lineHeight: '1.5', whiteSpace: 'pre-wrap', fontWeight: 500 }}>
                                    {logSelecionado.detalhes || '—'}
                                </p>
                            </div>

                            {/* Data e Hora */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: '#64748b', padding: '0 0.25rem' }}>
                                <span>Data/Hora do Log:</span>
                                <span style={{ color: '#cbd5e1', fontWeight: 500 }}>
                                    {formatDateTime(logSelecionado.criado_em || logSelecionado.criadoEm)}
                                </span>
                            </div>

                            {/* LIVE STATE (ESTADO EM TEMPO REAL) */}
                            <div style={{ 
                                marginTop: '0.5rem', 
                                borderTop: '1px solid rgba(255, 255, 255, 0.08)', 
                                paddingTop: '1rem' 
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                                    <h4 style={{ margin: 0, fontSize: '0.85rem', fontWeight: 700, color: '#a855f7', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <span className="live-dot" style={{
                                            width: '8px',
                                            height: '8px',
                                            background: '#a855f7',
                                            borderRadius: '50%',
                                            display: 'inline-block',
                                            boxShadow: '0 0 8px #a855f7',
                                            animation: 'adminPulse 1.5s infinite'
                                        }}></span>
                                        Estado Atual no Banco de Dados (Tempo Real)
                                    </h4>
                                    <span style={{ fontSize: '0.65rem', color: '#c084fc', background: 'rgba(168, 85, 247, 0.1)', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>
                                        LIVE STATE
                                    </span>
                                </div>

                                {detalhesCarregando ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8', fontSize: '0.8rem', padding: '1rem', justifyContent: 'center' }}>
                                        <div className="spinner" style={{ width: '16px', height: '16px', border: '2px solid rgba(255,255,255,0.1)', borderTopColor: '#a855f7', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }}></div>
                                        <span>Consultando status atual do alvo...</span>
                                    </div>
                                ) : erroDetalhes ? (
                                    <div style={{ color: '#f87171', fontSize: '0.8rem', background: 'rgba(239, 68, 68, 0.05)', padding: '0.75rem', borderRadius: '6px', border: '1px solid rgba(239, 68, 68, 0.1)' }}>
                                        {erroDetalhes}
                                    </div>
                                ) : !alvoDetalhes ? (
                                    <div style={{ background: 'rgba(239, 68, 68, 0.06)', border: '1px dashed rgba(239, 68, 68, 0.25)', padding: '1rem', borderRadius: '8px', color: '#fca5a5', fontSize: '0.8rem', textAlign: 'center', lineHeight: '1.4' }}>
                                        ⚠️ <strong>Alvo não localizado no banco de dados.</strong><br />
                                        <span style={{ color: '#f87171', fontSize: '0.7rem', display: 'block', marginTop: '4px' }}>
                                            Este usuário, anúncio ou cupom foi deletado definitivamente e seu registro atual não reside mais no banco.
                                        </span>
                                    </div>
                                ) : (
                                    <div style={{ 
                                        background: 'rgba(168, 85, 247, 0.04)', 
                                        border: '1px solid rgba(168, 85, 247, 0.15)', 
                                        borderRadius: '8px', 
                                        padding: '1rem' 
                                    }}>
                                        {/* Detalhes específicos de USUÁRIO */}
                                        {logSelecionado.alvo_tipo === 'usuario' && (
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem', fontSize: '0.8rem' }}>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Nome Completo:</span>
                                                    <strong style={{ color: '#f8fafc' }}>{alvoDetalhes.nome}</strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>E-mail:</span>
                                                    <strong style={{ color: '#f8fafc', wordBreak: 'break-all' }}>{alvoDetalhes.email}</strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Nível de Acesso:</span>
                                                    <span style={{
                                                        background: alvoDetalhes.cargo === 'admin' ? 'rgba(168, 85, 247, 0.2)' : 'rgba(255, 255, 255, 0.06)',
                                                        color: alvoDetalhes.cargo === 'admin' ? '#c084fc' : '#94a3b8',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.7rem',
                                                        fontWeight: 700,
                                                        textTransform: 'uppercase'
                                                    }}>
                                                        {alvoDetalhes.cargo === 'admin' ? 'ADMINISTRADOR 🛡️' : 'USUÁRIO COMUM'}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Status da Conta:</span>
                                                    <span style={{
                                                        background: alvoDetalhes.ativo ? 'rgba(34, 197, 94, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                                                        color: alvoDetalhes.ativo ? '#4ade80' : '#f87171',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.7rem',
                                                        fontWeight: 700
                                                    }}>
                                                        {alvoDetalhes.ativo ? 'ATIVA ✅' : 'BANIDA / INATIVA 🚫'}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Assinatura PRO:</span>
                                                    {alvoDetalhes.assinatura_ilimitada && alvoDetalhes.expiracao_assinatura && new Date(alvoDetalhes.expiracao_assinatura) > new Date() ? (
                                                        <>
                                                            <span style={{
                                                                background: 'rgba(245, 158, 11, 0.15)',
                                                                color: '#fbbf24',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '0.7rem',
                                                                fontWeight: 700
                                                            }}>
                                                                ATIVO (PRO 🌟)
                                                            </span>
                                                            <span style={{ display: 'block', fontSize: '0.65rem', color: '#94a3b8', marginTop: '2px' }}>
                                                                Expiração: {new Date(alvoDetalhes.expiracao_assinatura).toLocaleDateString('pt-BR')}
                                                            </span>
                                                        </>
                                                    ) : alvoDetalhes.assinatura_ilimitada && alvoDetalhes.expiracao_assinatura ? (
                                                        <>
                                                            <span style={{
                                                                background: 'rgba(239, 68, 68, 0.15)',
                                                                color: '#f87171',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '0.7rem',
                                                                fontWeight: 700
                                                            }}>
                                                                EXPIRADO
                                                            </span>
                                                            <span style={{ display: 'block', fontSize: '0.65rem', color: '#94a3b8', marginTop: '2px' }}>
                                                                Expirou em: {new Date(alvoDetalhes.expiracao_assinatura).toLocaleDateString('pt-BR')}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <span style={{
                                                            background: 'rgba(255, 255, 255, 0.06)',
                                                            color: '#94a3b8',
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.7rem',
                                                            fontWeight: 700
                                                        }}>
                                                            NÃO (STANDARD)
                                                        </span>
                                                    )}
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Perfil Motorista:</span>
                                                    {alvoDetalhes.motorista_verificado && alvoDetalhes.expiracao_motorista && new Date(alvoDetalhes.expiracao_motorista) > new Date() ? (
                                                        <>
                                                            <span style={{
                                                                background: 'rgba(14, 165, 233, 0.15)',
                                                                color: '#38bdf8',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '0.7rem',
                                                                fontWeight: 700
                                                            }}>
                                                                VERIFICADO 🚚
                                                            </span>
                                                            <span style={{ display: 'block', fontSize: '0.65rem', color: '#94a3b8', marginTop: '2px' }}>
                                                                Expiração: {new Date(alvoDetalhes.expiracao_motorista).toLocaleDateString('pt-BR')}
                                                            </span>
                                                        </>
                                                    ) : alvoDetalhes.motorista_verificado && alvoDetalhes.expiracao_motorista ? (
                                                        <>
                                                            <span style={{
                                                                background: 'rgba(239, 68, 68, 0.15)',
                                                                color: '#f87171',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '0.7rem',
                                                                fontWeight: 700
                                                            }}>
                                                                EXPIRADO 🚚
                                                            </span>
                                                            <span style={{ display: 'block', fontSize: '0.65rem', color: '#94a3b8', marginTop: '2px' }}>
                                                                Expirou em: {new Date(alvoDetalhes.expiracao_motorista).toLocaleDateString('pt-BR')}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <span style={{
                                                            background: 'rgba(255, 255, 255, 0.06)',
                                                            color: '#94a3b8',
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.7rem',
                                                            fontWeight: 700
                                                        }}>
                                                            NÃO VERIFICADO
                                                        </span>
                                                    )}
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Saldo de Créditos:</span>
                                                    <strong style={{ color: '#4ade80', fontSize: '0.85rem' }}>🎫 {alvoDetalhes.creditos || 0} créditos</strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Contato (WhatsApp/Tel):</span>
                                                    <strong style={{ color: '#f8fafc' }}>
                                                        {alvoDetalhes.whatsapp || alvoDetalhes.telefone || 'Não informado'}
                                                    </strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>CPF / CNPJ:</span>
                                                    <strong style={{ color: '#cbd5e1', fontFamily: 'monospace' }}>
                                                        {alvoDetalhes.cpf_cnpj || 'Não informado'}
                                                    </strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Localização:</span>
                                                    <strong style={{ color: '#cbd5e1' }}>
                                                        {alvoDetalhes.cidade && alvoDetalhes.estado ? `${alvoDetalhes.cidade} - ${alvoDetalhes.estado}` : 'Não informada'}
                                                    </strong>
                                                </div>
                                                {alvoDetalhes.nome_fazenda && (
                                                    <div>
                                                        <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Nome da Fazenda:</span>
                                                        <strong style={{ color: '#fbbf24' }}>🚜 {alvoDetalhes.nome_fazenda}</strong>
                                                    </div>
                                                )}
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Membro Desde:</span>
                                                    <span style={{ color: '#cbd5e1' }}>
                                                        {new Date(alvoDetalhes.criado_em).toLocaleDateString('pt-BR')}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Detalhes específicos de ANÚNCIO */}
                                        {logSelecionado.alvo_tipo === 'anuncio' && (
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem', fontSize: '0.8rem' }}>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Título do Anúncio:</span>
                                                    <strong style={{ color: '#f8fafc' }}>{alvoDetalhes.titulo}</strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Valor Cobrado:</span>
                                                    <strong style={{ color: '#22c55e', fontSize: '0.85rem' }}>
                                                        {alvoDetalhes.preco ? Number(alvoDetalhes.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'Sob consulta'}
                                                    </strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Status de Publicação:</span>
                                                    <span style={{
                                                        background: alvoDetalhes.ativo ? 'rgba(34, 197, 94, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                                                        color: alvoDetalhes.ativo ? '#4ade80' : '#f87171',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.7rem',
                                                        fontWeight: 700
                                                    }}>
                                                        {alvoDetalhes.ativo ? 'ATIVO ✅' : 'INATIVO / PAUSADO 💤'}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Visualizações:</span>
                                                    <strong style={{ color: '#60a5fa' }}>👁️ {alvoDetalhes.visualizacoes || 0} visualizações</strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Destaque da Home:</span>
                                                    <span style={{
                                                        background: alvoDetalhes.destaque ? 'rgba(245, 158, 11, 0.15)' : 'rgba(255, 255, 255, 0.06)',
                                                        color: alvoDetalhes.destaque ? '#fbbf24' : '#94a3b8',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.7rem',
                                                        fontWeight: 700
                                                    }}>
                                                        {alvoDetalhes.destaque ? '⭐ DESTACADO' : 'SEM DESTAQUE'}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Categoria:</span>
                                                    <span style={{ color: '#e2e8f0', fontWeight: 600 }}>{alvoDetalhes.categoria || 'Não especificada'}</span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Anunciante:</span>
                                                    <span style={{ color: '#cbd5e1' }}>{alvoDetalhes.anunciante_nome || '—'}</span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Publicado em:</span>
                                                    <span style={{ color: '#cbd5e1' }}>
                                                        {new Date(alvoDetalhes.data_criacao).toLocaleDateString('pt-BR')}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Detalhes específicos de CUPOM */}
                                        {logSelecionado.alvo_tipo === 'cupom' && (
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.75rem', fontSize: '0.8rem' }}>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Cupom:</span>
                                                    <strong style={{ color: '#f8fafc', letterSpacing: '0.5px', fontFamily: 'monospace' }}>{alvoDetalhes.codigo}</strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Desconto Oferecido:</span>
                                                    <strong style={{ color: '#4ade80' }}>
                                                        {alvoDetalhes.tipo === 'percentual' ? `${alvoDetalhes.valor}%` : Number(alvoDetalhes.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                    </strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Status do Cupom:</span>
                                                    <span style={{
                                                        background: alvoDetalhes.ativo ? 'rgba(34, 197, 94, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                                                        color: alvoDetalhes.ativo ? '#4ade80' : '#f87171',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '0.7rem',
                                                        fontWeight: 700
                                                    }}>
                                                        {alvoDetalhes.ativo ? 'ATIVO ✅' : 'INATIVO 🚫'}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Contador de Usos:</span>
                                                    <strong style={{ color: '#cbd5e1' }}>
                                                        {alvoDetalhes.usos_atuais} / {alvoDetalhes.limite_uso > 0 ? alvoDetalhes.limite_uso : 'Sem limite'}
                                                    </strong>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Tipo do Desconto:</span>
                                                    <span style={{ color: '#cbd5e1', textTransform: 'capitalize' }}>{alvoDetalhes.tipo}</span>
                                                </div>
                                                <div>
                                                    <span style={{ color: '#64748b', display: 'block', fontSize: '0.7rem' }}>Data Limite:</span>
                                                    <span style={{ color: '#cbd5e1' }}>
                                                        {alvoDetalhes.validade ? new Date(alvoDetalhes.validade).toLocaleDateString('pt-BR') : 'Sem validade'}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                        </div>

                        {/* Modal Footer */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1.25rem', borderTop: '1px solid rgba(255, 255, 255, 0.08)', paddingTop: '1rem' }}>
                            <button 
                                className="admin-btn admin-btn-secondary" 
                                onClick={() => setLogSelecionado(null)}
                                style={{ padding: '0.5rem 1.25rem', borderRadius: '8px' }}
                            >
                                Fechar Detalhes
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Injeção de Estilo Autocontido */}
            <style dangerouslySetInnerHTML={{__html: `
                .admin-log-row:hover {
                    background: rgba(255, 255, 255, 0.05) !important;
                    transform: translateX(4px);
                }
                @keyframes adminModalFadeIn {
                    from { opacity: 0; transform: scale(0.96) translateY(10px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                }
                @keyframes adminPulse {
                    0% { transform: scale(0.85); opacity: 0.4; }
                    50% { transform: scale(1.2); opacity: 1; }
                    100% { transform: scale(0.85); opacity: 0.4; }
                }
            `}} />
        </div>
    )
}

export default AdminLogs
